// © Microsoft Corporation. All rights reserved.

import { ITargetScope } from "@msnews/config-data-types";
import { WpoModel } from ".";

/**
 * Get storage cache key used to store WPO service response.
 * @param {string} appType - The appType value.
 * @param {ITargetScope} targetScope - The current page request target scope.
 * @returns string - Cache key string.
 */
export function getWpoStorageCacheKey(appType: string, targetScope: ITargetScope): string {
    const { audienceMode = "", locale = {}, pageType = "" } = targetScope || {};
    const { language, market } = locale;

    return `wpo_data_ ${audienceMode}_${language}_${market}_${pageType}_${appType}`;
}

/**
 * Extracts the WPO flight ids from the WPOModel object.
 * @param {WpoModel} wpoData - The WPOModel object.
 * @returns string[] - Array of WPO recommended flight ids
 */
export function getWpoFlights(wpoData: WpoModel): string[] | null {
    if (!wpoData || !wpoData.treatments) {
        return null;
    }

    return wpoData.treatments.map(item => item.id);
}